module.exports = __webpack_public_path__ + "img/rg3.8ce01a90.jpg";